export default __webpack_public_path__ + "static/media/vid.1dda9b2f.mp4";